  $(document).ready(function(){
      $(".block__main-hero-marquee-wrapper").slick({
        draggable: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 0,
        speed: 5000,
        pauseOnHover: false,
        cssEase: 'linear',
        variableWidth: true
      });
      if(window.innerWidth < 768){
        $(".block__main-hero-inner-logos").slick({
        draggable: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 0,
        speed: 5000,
        pauseOnHover: false,
        cssEase: 'linear',
        variableWidth: true
      });
      }
  })